let ctx = null;
let unlocked = false;

const unlock = () => {
  if (!ctx) {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return;
    try {
      ctx = new AC();
    } catch {
      return;
    }
  }
  if (ctx.state === 'suspended') ctx.resume();
  unlocked = true;
  window.removeEventListener('pointerdown', unlock);
  window.removeEventListener('keydown', unlock);
};

export const initSound = () => {
  if (unlocked) return;
  window.addEventListener('pointerdown', unlock);
  window.addEventListener('keydown', unlock);
};

export const playNotificationSound = () => {
  if (!ctx || !unlocked || ctx.state !== 'running') return;
  const t = ctx.currentTime;
  const notes = [
    [880, 0],
    [1174.66, 0.14],
  ];
  notes.forEach(([freq, delay]) => {
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.type = 'sine';
    osc.frequency.value = freq;
    gain.gain.setValueAtTime(0.0001, t + delay);
    gain.gain.exponentialRampToValueAtTime(0.25, t + delay + 0.02);
    gain.gain.exponentialRampToValueAtTime(0.0001, t + delay + 0.35);
    osc.connect(gain);
    gain.connect(ctx.destination);
    osc.start(t + delay);
    osc.stop(t + delay + 0.4);
  });
};
